<template>
  <div
    :class="{ 'operations-list-component': true, 'operations-list-component--inner': innerGroup }"
  >
    <OperationListSkeleton v-if="!listItems && !innerGroup">
      <OperationItemSkeleton />
    </OperationListSkeleton>

    <OperationListSkeleton v-if="!listItems && innerGroup">
      <OperationListSkeleton innerGroup>
        <OperationItemSkeleton />
      </OperationListSkeleton>
    </OperationListSkeleton>
    <template
      v-for="(listItem, index) in listItems"
      :key="listItem.id"
    >
      <div
        v-if="show(listItem?.mines, 'shafts') || show(listItem?.mines, 'equipments')"
        class="operations-list-component-item"
      >
        <div
          v-if="show(listItem)"
          :class="{
            'operations-list-component-item__title typo-small-text': true,
            'operations-list-component-item__title--inner': innerGroup
          }"
        >
          {{ renderTitle(listItem.name) }}
        </div>
        <div
          v-if="show(listItem)"
          :class="{
            'operations-list-component-item__content': true,
            'operations-list-component-item__content--inner': innerGroup
          }"
        >
          <slot
            v-if="isShaft || isEquipment"
            :item="{listItem, index}"
          />
          <slot
            v-else
            :item="listItem"
          />
        </div>
      </div>
    </template>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import I18n from 'i18n-js';

// Components
import OperationItemSkeleton from '@/components/operations/operation_item_skeleton.vue';
import OperationListSkeleton from '@/components/operations/operation_list_skeleton.vue';

const props = defineProps({
  organisationId: { type: String, default: null },
  listItems: { type: Object, default: null },
  innerGroup: { type: Boolean, default: false },
  operationType: { type: String, required: true, default: null },
});

const isShaft = computed(() => props.operationType === 'shafts');
const isEquipment = computed(() => props.operationType === 'equipments');

function renderTitle(title) {
  switch(title) {
    case 'plants':
      return `${I18n.t('nav.plants')}`;
    case 'shafts_v2_shafts':
      return `${I18n.t('nav.shafts')}`;
    case 'ships':
      return `${I18n.t('nav.ships')}`;
    case 'equipments':
      return `${I18n.t('nav.equipment')}`;
    case 'none':
      return `${I18n.t('nav.none')}`;
    default:
      return title;
  }
}

/**
 * Show section if the list is greater than 0
 */
function show(data, key) {
  if (!data) return true;
  let showItem = false;
  Object.entries(data).forEach(item => {
    if (!key && !showItem && typeof item[1] === 'object') {
      showItem = item[1]?.length > 0;
    } else if (!showItem && typeof item[1][key] === 'object') {
      showItem = item[1][key]?.length > 0;
    }
  });
  return showItem;
}
</script>
<style scoped lang="scss">
@import '@/stylesheets/global';

.operations-list-component-item {
  &__title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
  }
}
</style>
